import { render, staticRenderFns } from "./ComprobanteTraspasoPage.vue?vue&type=template&id=7b81a4e3"
import script from "./ComprobanteTraspasoPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteTraspasoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports